import { Button, Flex, Modal } from "antd";
import Title from "antd/es/typography/Title";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { CustomTitle } from "../../../../common/customTitle";
import { deleteFlashMessageByIdAction } from "../../../../../redux/services/flash-message/flashMessageServices";
import { useTranslation } from "react-i18next";

const FlashMessageDeleteDialog = ({ open, onClose, selectedFlashMessageId, callListApi }) => {

  const {t} = useTranslation();
  
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);

  /* perform delete action */
  const handleDelete = () => {
    if (selectedFlashMessageId?.length) {
      const dataToBeSent = {
        selectedFlashMessageId,
      };
      setLoading(true);
      dispatch(deleteFlashMessageByIdAction(dataToBeSent)).then(() => {
        onClose();
        callListApi()
        setLoading(false);
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
      <CustomTitle textDecoration="underline" justifyContent="center">
      {t("Modules.Offer.OfferForm.deleteOffer")}
      </CustomTitle>
      <Title level={2}>
      {t("deleteTitle")}
      </Title>
      <Flex gap="1rem" align="center" justify="center">
      <Button type="primary" onClick={handleDelete}>
      {t("confirmationPopup.buttonYesText")}
      </Button>
      <Button type="default" onClick={onClose}>
      {t("confirmationPopup.buttonNoText")}
      </Button>
      </Flex>
      </Flex>
    </Modal>
  );
};

export default FlashMessageDeleteDialog;
